export const offerStatuses = {
  active: 'Ativa',
  expired: 'Expirada',
  scheduled: 'Agendada',
};
